import { Component, OnInit, AfterViewInit, OnDestroy, Input, forwardRef, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Course, Section } from '@shared/models';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormGroup, FormControlDirective, ControlContainer } from '@angular/forms';
import { FormControl, FormBuilder } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { PaginatedScrollService, PaginatedScrollController } from '@shared/services/paginated-scroll.service';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'experience-selector',
  templateUrl: './experience-selector.component.html',
  styles: [
    `
      .select-container{
        width: 100%;
      }

    `
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ExperienceSelectorComponent,
      multi: true
    }
  ]
})
export class ExperienceSelectorComponent implements OnInit, AfterViewInit, OnDestroy, ControlValueAccessor {
  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;
  @ViewChildren(MatSelect) matSelectList: QueryList<MatSelect>;
  @Input()
  formControl: FormControl;

  @Input()
  formControlName: string;
  @Input() learnspaceId: string;
  courses: Course[];
  select: FormGroup;

  private _paginatedController: PaginatedScrollController<Course>;
  private _openChangeSub: Subscription;

  constructor(
    private _courseApiService: CoursesAPIService,
    private controlContainer: ControlContainer,
    private _paginatedScrollService: PaginatedScrollService
  ) {

  }
  get control() {
    return this.formControl || this.controlContainer.control.get(this.formControlName);
  }

  ngOnInit(): void {
    this._paginatedController = this._paginatedScrollService.createController(
      (options) => this._courseApiService.getLearnspaceCourseList(this.learnspaceId, options).pipe(
        map(r => ({ total: r.total, items: r.courses }))
      ),
      (courses) => { this.courses = courses; },
      { pageSize: 20, sort: 'title' }
    );
    this._paginatedController.reload().subscribe();
  }

  ngAfterViewInit(): void {
    this.matSelectList.changes.subscribe((list: QueryList<MatSelect>) => {
      if (list.first && !this._openChangeSub) {
        this._openChangeSub = list.first.openedChange.subscribe(isOpen => {
          if (isOpen) {
            this._paginatedController.attachScroll(list.first.panel.nativeElement);
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
    this._openChangeSub?.unsubscribe();
    this._paginatedController?.destroy();
  }
  registerOnTouched(fn: any): void {
    if (this.formControlDirective) {
      this.formControlDirective.valueAccessor.registerOnTouched(fn);
    }
  }

  registerOnChange(fn: any): void {
    if (this.formControlDirective) {
      this.formControlDirective.valueAccessor.registerOnChange(fn);
    }
  }

  writeValue(obj: any): void {
    if (this.formControlDirective) {
      this.formControlDirective.valueAccessor.writeValue(obj);
    }
  }
  getCourseOptionValue(course: Course): string {
    let value = course.title;
    value += (course.public_status === 'private') ? ' (private)' : '';
    return value;
  }

}
